var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcoSheetHidden(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.07436 10.4581C2.91321 9.75948 2.18569 8.8675 1.89706 8.46874C2.40711 7.76415 4.28268 5.52343 7.49999 5.52343C7.98676 5.52343 8.44228 5.57539 8.86754 5.66489L9.54228 4.99015C8.92735 4.817 8.24792 4.71094 7.49999 4.71094C3.23091 4.71094 1.14442 8.11515 1.05769 8.26016C0.980771 8.3886 0.980771 8.54888 1.05769 8.67732C1.11041 8.76546 1.90355 10.0573 3.47511 11.0573L4.07436 10.4581Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.5252 5.87988L10.9259 6.47912C12.0868 7.17756 12.8143 8.06936 13.1032 8.46847C12.5932 9.17306 10.7177 11.4138 7.50032 11.4138C7.01355 11.4138 6.55801 11.3618 6.13275 11.2723L5.45801 11.9471C6.07294 12.1202 6.75238 12.2263 7.50032 12.2263C11.7694 12.2263 13.8559 8.82206 13.9427 8.67705C14.0195 8.54861 14.0195 8.38833 13.9427 8.25989C13.8899 8.17175 13.0968 6.87993 11.5252 5.87988Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.50037 10.9066C8.84657 10.9066 9.93786 9.81531 9.93786 8.46912C9.93786 8.1705 9.88393 7.88453 9.78566 7.62012L6.65137 10.7544C6.91577 10.8527 7.20175 10.9066 7.50037 10.9066Z",
    fill: "black"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M5.0625 8.46874C5.0625 8.76737 5.11644 9.05333 5.21471 9.31774L8.34899 6.18345C8.08458 6.08518 7.79862 6.03125 7.49999 6.03125C6.15379 6.03125 5.0625 7.12255 5.0625 8.46874Z",
    fill: "black"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5996 4.40039L3.76077 13.2392",
    stroke: "black",
    strokeWidth: 0.8
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoSheetHidden);
export default __webpack_public_path__ + "static/media/ico-sheet-hidden.6be10a75ee36f982f940da4a57f0379c.svg";
export { ForwardRef as ReactComponent };